var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-action-icon',{staticClass:"mr-4",attrs:{"icon":_vm.$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'},on:{"click":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }